import { useState } from 'react';
import {
  Music, Dumbbell, Palette, GraduationCap, Code, TreePine, Users, Lightbulb,
  Camera, Film, BookOpen, Globe, Heart, Star, Zap, Trophy,
  Mic, Guitar, Drama, Paintbrush, Rocket, Bike, Mountain, Waves,
  Sun, Moon, Sparkles, PartyPopper, Megaphone, HandHelping, Building2,
  MapPin, Landmark, Church, Tent, Ticket, Gift, Coffee, UtensilsCrossed,
  Baby, Dog, Flower2, Leaf, Recycle, Shield, Scale, Gavel,
  type LucideIcon,
} from 'lucide-react';

export const ICON_MAP: Record<string, LucideIcon> = {
  music: Music, dumbbell: Dumbbell, palette: Palette, 'graduation-cap': GraduationCap,
  code: Code, 'tree-pine': TreePine, users: Users, lightbulb: Lightbulb,
  camera: Camera, film: Film, 'book-open': BookOpen, globe: Globe,
  heart: Heart, star: Star, zap: Zap, trophy: Trophy,
  mic: Mic, guitar: Guitar, drama: Drama, paintbrush: Paintbrush,
  rocket: Rocket, bike: Bike, mountain: Mountain, waves: Waves,
  sun: Sun, moon: Moon, sparkles: Sparkles, 'party-popper': PartyPopper,
  megaphone: Megaphone, 'hand-helping': HandHelping, 'building-2': Building2,
  'map-pin': MapPin, landmark: Landmark, church: Church, tent: Tent,
  ticket: Ticket, gift: Gift, coffee: Coffee, 'utensils-crossed': UtensilsCrossed,
  baby: Baby, dog: Dog, 'flower-2': Flower2, leaf: Leaf,
  recycle: Recycle, shield: Shield, scale: Scale, gavel: Gavel,
};

const ALL_ICONS = Object.entries(ICON_MAP);

interface IconPickerProps {
  value: string;
  onChange: (iconName: string) => void;
}

export function IconPicker({ value, onChange }: IconPickerProps) {
  const [search, setSearch] = useState('');

  const filtered = search
    ? ALL_ICONS.filter(([name]) => name.includes(search.toLowerCase()))
    : ALL_ICONS;

  return (
    <div>
      <input
        type="text"
        placeholder="Caută iconiță..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="mb-3 w-full rounded-lg border px-3 py-2 text-sm outline-none transition-colors focus:border-[var(--vivid-purple)] focus:ring-2 focus:ring-[var(--vivid-purple)]/20"
        style={{ fontFamily: 'var(--font-secondary)' }}
      />
      <div className="grid max-h-48 grid-cols-8 gap-1.5 overflow-y-auto sm:grid-cols-10">
        {filtered.map(([name, Icon]) => (
          <button
            key={name}
            type="button"
            onClick={() => onChange(name)}
            className={`flex h-9 w-9 items-center justify-center rounded-lg transition-colors ${
              value === name
                ? 'bg-[var(--vivid-purple)] text-white'
                : 'bg-gray-50 text-muted-foreground hover:bg-gray-100 hover:text-foreground'
            }`}
            title={name}
          >
            <Icon className="h-4 w-4" />
          </button>
        ))}
      </div>
      {filtered.length === 0 && (
        <p className="py-4 text-center text-xs text-muted-foreground">Nicio iconiță găsită</p>
      )}
    </div>
  );
}

/** Render an icon by name. Returns null if not found. */
export function IconByName({ name, className, style }: { name: string; className?: string; style?: React.CSSProperties }) {
  const Icon = ICON_MAP[name];
  if (!Icon) return null;
  return <Icon className={className || 'h-4 w-4'} style={style} />;
}
